import React from "react";
import styles from "./HomePage.module.css";

export function HomePage() {
  return <div className={styles.container}>Example page</div>;
}

export default HomePage;
